export enum OrderSettleType {
  STORE_PRODUCT_PRICE = 'STORE_PRODUCT', // 그냥 쇼핑몰에서 구매한 상품 정산
  RESELLER_PRODUCT_PRICE = 'RESELLER_PRODUCT', // 리셀러를 통해서 구매한 상품 정산
  DELIVERY_PRICE = 'DELIVERY' // 택배비 정산
}
